import { ref } from "vue";
import ApiService from "@/core/services/ApiService";

export type SortDir = "asc" | "desc";

export function useLogTable(endpoint: string) {
  const loading = ref(false);
  const rows = ref<any[]>([]);
  const total = ref(0);
  const page = ref(1);
  const pageSize = ref(10);
  const sortBy = ref<string>("");
  const sortDir = ref<SortDir>("desc");

  // filters
  const dateRange = ref<[Date, Date] | []>([]);
  const text = ref<string>("");
  const username = ref<string>("");
  const orgcode = ref<string>("");
  const clientIp = ref<string>("");
  const method = ref<string>("");
  const providerRegnum = ref<string>("");
  const providerBranch = ref<string>("");
  const patchId = ref<string>("");

  const day = (d: Date) => new Date(d).toISOString().slice(0, 10);

  const fetch = async () => {
    loading.value = true;
    try {
      const params: any = {
        page: page.value,
        pageSize: pageSize.value,
        sortBy: sortBy.value || null,
        sortDir: sortDir.value || "desc",
        dateStart: dateRange.value?.length
          ? day(dateRange.value[0] as Date)
          : null,
        dateEnd: dateRange.value?.length
          ? day(dateRange.value[1] as Date)
          : null,
        text: text.value || null,
        username: username.value || null,
        orgcode: orgcode.value || null,
        clientIp: clientIp.value || null,
        method: method.value || null,
        providerRegnum: providerRegnum.value || null,
        providerBranch: providerBranch.value || null,
        patchId: patchId.value || null
      };
      const res = await ApiService.postWithRawBody(endpoint, { params });
      if (res.data?.code === 1) {
        rows.value = res.data.response.rows || [];
        total.value = res.data.response.total || 0;
      } else {
        rows.value = [];
        total.value = 0;
      }
    } finally {
      loading.value = false;
    }
  };

  const onSort = (e: any) => {
    sortBy.value = e?.prop || "";
    sortDir.value = e?.order === "ascending" ? "asc" : "desc";
    page.value = 1;
    fetch();
  };

  const onPage = (p: number) => {
    page.value = p;
    fetch();
  };
  const onPageSize = (n: number) => {
    pageSize.value = n;
    page.value = 1;
    fetch();
  };

  const shortcuts = [
    { text: "Өчигдөр", value: [new Date(Date.now() - 86400000), new Date()] },
    {
      text: "7 өдөр",
      value: [new Date(Date.now() - 7 * 86400000), new Date()]
    },
    {
      text: "30 өдөр",
      value: [new Date(Date.now() - 30 * 86400000), new Date()]
    }
  ];

  return {
    // state
    loading,
    rows,
    total,
    page,
    pageSize,
    sortBy,
    sortDir,
    dateRange,
    text,
    username,
    orgcode,
    clientIp,
    method,
    providerRegnum,
    providerBranch,
    patchId,
    // actions
    fetch,
    onSort,
    onPage,
    onPageSize,
    shortcuts
  };
}
